// shop.js — точка входа магазина
// =============================================================================
// Отдельный бандл от app.js: корзина нужна на витрине, карточке товара и трёх
// шагах заказа, но это код проекта, а не библиотеки — в app.js ему не место.

import * as cart from './shop/cart.js';
import * as fader from './shop/fader.js';
import { init } from './shop/ui.js';

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

// Отладка из консоли: window.SmolaCart.state(), window.SmolaFade.show(node, 1)
window.SmolaCart = cart;
window.SmolaFade = fader;
